/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/* Template custom: api */

import {
  ApiAddParticipantDto,
  ApiChatResponse,
  ApiCreateChatDto,
  ApiCreateMessageDto,
  ApiMessageResponse,
  ApiParticipantResponse,
  ApiReadMessageBatchDto,
  ApiUpdateChatDto,
  ApiUpdateMessageDto,
} from "./data-contracts";
import {
  ApiBaseError,
  ContentType,
  HttpClient,
  RequestParams,
} from "./http-client";

export class GtwChat<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Chats
   * @name ChatControllerFindAll
   * @summary Get list of all chats
   * @request GET:/gtw/chat/chats
   * @secure
   * @response `200` `(ApiChatResponse)[]` List of chats successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  chatControllerFindAll = (params: RequestParams = {}) =>
    this.request<ApiChatResponse[], ApiBaseError>({
      path: `/gtw/chat/chats`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Chats
   * @name ChatControllerCreate
   * @summary Create a new chat
   * @request POST:/gtw/chat/chats
   * @secure
   * @response `201` `ApiChatResponse`
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  chatControllerCreate = (data: ApiCreateChatDto, params: RequestParams = {}) =>
    this.request<ApiChatResponse, ApiBaseError>({
      path: `/gtw/chat/chats`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Chats
   * @name ChatControllerFindSharedWith
   * @summary Get list of chats shared with a participant
   * @request GET:/gtw/chat/chats/shared-with/{profileId}
   * @secure
   * @response `200` `(ApiChatResponse)[]` List of shared chats successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  chatControllerFindSharedWith = (
    profileId: number,
    params: RequestParams = {},
  ) =>
    this.request<ApiChatResponse[], ApiBaseError>({
      path: `/gtw/chat/chats/shared-with/${profileId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Chats
   * @name ChatControllerFindOne
   * @summary Get a chat by ID
   * @request GET:/gtw/chat/chats/{id}
   * @secure
   * @response `200` `ApiChatResponse` Chat successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  chatControllerFindOne = (
    id: string,
    query?: {
      /* Template custom: data-contract-jsdoc */
      limit?: number;
      /* Template custom: data-contract-jsdoc */
      offset?: number;
      /* Template custom: data-contract-jsdoc */
      before?: string;
      /* Template custom: data-contract-jsdoc */
      after?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ApiChatResponse, ApiBaseError>({
      path: `/gtw/chat/chats/${id}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Chats
   * @name ChatControllerUpdate
   * @summary Update a chat
   * @request PUT:/gtw/chat/chats/{id}
   * @secure
   * @response `200` `ApiChatResponse`
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  chatControllerUpdate = (
    id: string,
    data: ApiUpdateChatDto,
    query?: {
      /* Template custom: data-contract-jsdoc */
      limit?: number;
      /* Template custom: data-contract-jsdoc */
      offset?: number;
      /* Template custom: data-contract-jsdoc */
      before?: string;
      /* Template custom: data-contract-jsdoc */
      after?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ApiChatResponse, ApiBaseError>({
      path: `/gtw/chat/chats/${id}`,
      method: "PUT",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Chats
   * @name ChatControllerDelete
   * @summary Delete a chat
   * @request DELETE:/gtw/chat/chats/{id}
   * @secure
   * @response `204` `void` Chat successfully deleted
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  chatControllerDelete = (id: string, params: RequestParams = {}) =>
    this.request<void, ApiBaseError>({
      path: `/gtw/chat/chats/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Participants
   * @name ParticipantControllerFindAll
   * @summary Get list of chat participants
   * @request GET:/gtw/chat/chats/{chatId}/participants
   * @secure
   * @response `200` `(ApiParticipantResponse)[]` List of participants successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  participantControllerFindAll = (chatId: string, params: RequestParams = {}) =>
    this.request<ApiParticipantResponse[], ApiBaseError>({
      path: `/gtw/chat/chats/${chatId}/participants`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Participants
   * @name ParticipantControllerCreate
   * @summary Add a participant to the chat
   * @request POST:/gtw/chat/chats/{chatId}/participants
   * @secure
   * @response `201` `ApiParticipantResponse`
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  participantControllerCreate = (
    chatId: string,
    data: ApiAddParticipantDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiParticipantResponse, ApiBaseError>({
      path: `/gtw/chat/chats/${chatId}/participants`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Participants
   * @name ParticipantControllerLeave
   * @summary Leave the chat
   * @request DELETE:/gtw/chat/chats/{chatId}/participants/me
   * @secure
   * @response `204` `void` Successfully left the chat
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  participantControllerLeave = (chatId: string, params: RequestParams = {}) =>
    this.request<void, ApiBaseError>({
      path: `/gtw/chat/chats/${chatId}/participants/me`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Participants
   * @name ParticipantControllerDelete
   * @summary Remove a participant from the chat
   * @request DELETE:/gtw/chat/chats/{chatId}/participants/{profileId}
   * @secure
   * @response `204` `void` Participant successfully removed
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  participantControllerDelete = (
    chatId: string,
    profileId: number,
    params: RequestParams = {},
  ) =>
    this.request<void, ApiBaseError>({
      path: `/gtw/chat/chats/${chatId}/participants/${profileId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Messages
   * @name MessageControllerFindAll
   * @summary Get list of chat messages
   * @request GET:/gtw/chat/messages
   * @secure
   * @response `200` `(ApiMessageResponse)[]` List of messages successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  messageControllerFindAll = (
    query: {
      /* Template custom: data-contract-jsdoc */
      chatId: string;
      /* Template custom: data-contract-jsdoc */
      limit?: number;
      /* Template custom: data-contract-jsdoc */
      offset?: number;
      /* Template custom: data-contract-jsdoc */
      before?: string;
      /* Template custom: data-contract-jsdoc */
      after?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ApiMessageResponse[], ApiBaseError>({
      path: `/gtw/chat/messages`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Messages
   * @name MessageControllerCreate
   * @summary Create a new message
   * @request POST:/gtw/chat/messages
   * @secure
   * @response `201` `ApiMessageResponse`
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  messageControllerCreate = (
    data: ApiCreateMessageDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiMessageResponse, ApiBaseError>({
      path: `/gtw/chat/messages`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Messages
   * @name MessageControllerFindOne
   * @summary Get a message by ID
   * @request GET:/gtw/chat/messages/{messageId}
   * @secure
   * @response `200` `ApiMessageResponse` Message successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  messageControllerFindOne = (messageId: string, params: RequestParams = {}) =>
    this.request<ApiMessageResponse, ApiBaseError>({
      path: `/gtw/chat/messages/${messageId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Messages
   * @name MessageControllerUpdate
   * @summary Update a message
   * @request PUT:/gtw/chat/messages/{messageId}
   * @secure
   * @response `200` `ApiMessageResponse`
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  messageControllerUpdate = (
    messageId: string,
    data: ApiUpdateMessageDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiMessageResponse, ApiBaseError>({
      path: `/gtw/chat/messages/${messageId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Messages
   * @name MessageControllerDelete
   * @summary Delete a message
   * @request DELETE:/gtw/chat/messages/{messageId}
   * @secure
   * @response `204` `void` Message successfully deleted
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  messageControllerDelete = (messageId: string, params: RequestParams = {}) =>
    this.request<void, ApiBaseError>({
      path: `/gtw/chat/messages/${messageId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Messages
   * @name MessageControllerMarkBatchAsRead
   * @summary Mark messages as read
   * @request POST:/gtw/chat/messages/read-batch
   * @secure
   * @response `200` `(ApiMessageResponse)[]` Messages successfully marked as read
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  messageControllerMarkBatchAsRead = (
    data: ApiReadMessageBatchDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiMessageResponse[], ApiBaseError>({
      path: `/gtw/chat/messages/read-batch`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
